// External Libraries
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

// UI Components
import FormField from '../../components/ui/FormField';
import SelectBox from '../../components/ui/SelectBox';
import CheckboxField from '../../components/ui/CheckboxField';
import SubmitButton from '../../components/ui/SubmitButton';

// Redux Actions
import { updateStateFunc } from '../../../store/custom-actions/states-actions/UpdateStateSlicer';
import { getStatesFunc } from '../../../store/custom-actions/states-actions/GetStatesSlicer';
import { getCountriesFunc } from '../../../store/custom-actions/countries-actions/GetContriesSlicer';


function UpdateStateForm({ show, onHide, stateId, oldName, oldCode, oldShipping, oldStatus, oldCountry }) {
  const { t } = useTranslation()
  const { register, reset, formState: { errors }, handleSubmit, setValue } = useForm();
  const { loading: submitLoading } = useSelector(state => state.updateStateSlicer);
  const dispatch = useDispatch();

  const { loading: getCountriesLoading, data: countriesData } = useSelector(state => state.getCountriesSlicer)
  const [countriesList, setCountriesList] = useState([]);

  useEffect(() => {
    dispatch(getCountriesFunc())
  }, []);

  useEffect(() => {
    countriesData && setCountriesList(countriesData);
  }, [countriesData]);

  useEffect(() => {
    setValue("name", oldName);
    setValue("code", oldCode);
    setValue("shipping_amount", oldShipping);
    setValue("country_id", oldCountry);
    setValue("active", oldStatus);
  }, [setValue, oldName, oldCode, oldStatus, oldShipping, oldCountry])

  const resetForm = () => {
    onHide();
    reset();
  };

  const onSubmit = async (data) => {
    const payload = {
      ...data,
    };

    const result = await dispatch(updateStateFunc({ id: stateId, data: payload }))
    if (updateStateFunc.fulfilled.match(result)) {
      dispatch(getStatesFunc());
      resetForm();
    }
  }

  return (
    <>
      <Modal show={show} onHide={onHide}>
        <Modal.Header closeButton>
          <Modal.Title>{t('Update')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form
            id="submit-form-update"
            onSubmit={handleSubmit(onSubmit)}
          >
            <FormField
              label="Name"
              name="name"
              register={register}
              required={true}
              errors={errors}
            />
            <FormField
              label="Shipping"
              name="shipping_amount"
              register={register}
              required={true}
              errors={errors}
            />
            <FormField
              label="Code"
              name="code"
              register={register}
              required={true}
              errors={errors}
            />
            <div className='mb-3'>
              <SelectBox
                label={t("Country")}
                showLabel={true}
                name="country_id"
                register={register}
                data={countriesList}
                loading={getCountriesLoading}
                placeholder={t("Choose Country")}
                required={true}
                errors={errors}
              />
            </div>
            <CheckboxField
              name="active"
              label="Activity"
              register={register}
              errors={errors}
              defaultChecked={true}
            />
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            {t('Close')}
          </Button>
          <SubmitButton
            isLoading={submitLoading}
            form="submit-form-update"
          />
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default UpdateStateForm;
